import React from 'react'

const Loading = () =>{
    return <div style={{margin:"50px auto",width:"400px",height:"200px",background:"#FFF"}}><img src="/images/spinner.gif"  /></div>
}
export default Loading